import { Component, OnInit } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import { ApiUrls } from 'src/app/shared/const/Api-urls';

// import { PageDataService } from 'src/app/core/services/page-data.service';

import {
  PageCO,
  PageCategoryCO,
  PageContentCO
} from 'src/app/shared/models/ApiModels';

import { PageCategoryType } from 'src/app/shared/models/ApiModels';
import { PageDataService } from 'src/app/shared/services/page-data.service';

@Component({
  selector: 'app-about-us-v2',
  templateUrl: './about-us-v2.component.html',
  styleUrls: ['./about-us-v2.component.scss']
})
export class AboutUsV2Component implements OnInit {

  aboutUs?: PageCategoryCO;
  aboutUsContent?: PageContentCO;

  aboutUsImage = '';

  constructor(
    private pageDataService: PageDataService
  ) {}

  ngOnInit(): void {
    this.pageDataService.loadPageData();

    this.pageDataService.pageData$
      .pipe(
        map((pages: PageCO[] | null) =>
          pages?.find(
            page => page?.name?.toLowerCase() === 'home'
          )
        ),
        tap(homePage => {
          if (!homePage) {
            return;
          }

          this.buildAboutUs(homePage);
        })
      )
      .subscribe();
  }

  private buildAboutUs(page: PageCO): void {

    const aboutUs = page.category?.find(
      category =>
        category.category === PageCategoryType.AboutUs
    );

    if (!aboutUs) {
      return;
    }

    this.aboutUs = aboutUs;

    this.aboutUsImage =
      aboutUs.image?.[0]
        ? this.getFileUrl(
            aboutUs.image[0].file.fileUUID
          )
        : '';

    this.aboutUsContent =
      aboutUs.content?.[0];
  }

  private getFileUrl(uuid: string): string {
    return `${ApiUrls.downloadFileUrl1}${uuid}`;
  }
}